document.addEventListener('DOMContentLoaded', () => {

    // When cancel is clicked.
    let EarlyCancelButton = document.querySelector('.button.subscription_cancel_early');
    let cancelButton = document.querySelector('.button.cancel');
    let closePopup = document.querySelector('.purovitalis-popup--close');
    let closeCancelPopup = document.querySelector('.close-cancel-popup');
    let popup = document.querySelector('.purovitalis-popup.early-cancel-popup');

    if (EarlyCancelButton !== null) {
        EarlyCancelButton.addEventListener('click', function() {
            if (popup !== null && cancelButton !== null) {
                popup.classList.add('popup-open');
                cancelButton.innerHTML = 'Confirm cancellation';

                // Move cancel button to the popup actions.
                popup.querySelector('.purovitalis-popup--actions').appendChild(cancelButton);
            }
        });
    }

    if (closePopup !== null) {
        closePopup.addEventListener('click', function() {
            if (popup !== null) {
                popup.classList.remove('popup-open');
                cancelButton.innerHTML = 'Cancel';

                // Move cancel button back to actions.
                // EarlyCancelButton.parentNode.insertAfter(cancelButton, EarlyCancelButton);
            }
        });
    }

    if (closeCancelPopup !== null) {
        closeCancelPopup.addEventListener('click', function() {
            if (popup !== null) {
                popup.classList.remove('popup-open');
                cancelButton.innerHTML = 'Cancel';

                // Move cancel button back to actions.
                // EarlyCancelButton.parentNode.insertAfter(cancelButton, EarlyCancelButton);
            }
        });
    }

    if (cancelButton !== null) {
        cancelButton.addEventListener('click', function() {
            popup.classList.remove('popup-open');
            cancelButton.innerHTML = 'Cancel';

            // Move cancel button back to actions.
            // EarlyCancelButton.parentNode.insertAfter(cancelButton, EarlyCancelButton);
        });
    }

});